<template>
    <div class="wrap">
        <img :src="`${publicPath}/img/tuichu.png`"
             style="width: 25px; float: left;color: white;position: absolute;top:10px;left: 10px;z-index: 2000"
             @click="logOut">
        <!--        <my-header title="团员团干部注册审批"></my-header>-->
        <!--头部-->

        <div class="hd">
            <div class="info">
                <img src="../../../static/img/logo.png" alt="">
                <p>{{info.name}}</p>
            </div>

        </div>
        <!--<div style="overflow: hidden;padding: 0 20px"
             v-if="info.status == 1">
            <br>
            <van-button
                    color="#e32322"
                    style="padding:0 26px; border-radius:6px; height:38px; float: right; width: 8em"
                    @click="revokeStart"
            >撤销申请
            </van-button>
        </div>-->

        <van-steps :active="active" active-icon="success" active-color="#e32322">
            <van-step>提交申请</van-step>
            <van-step>团支部及直属上级审批</van-step>
            <van-step>完成</van-step>
        </van-steps>

        <van-cell-group>
            <van-cell title="姓名" :value="info.name"/>
            <van-cell title="所在团支部" :value="info.leagueFullName"/>
            <van-cell title="身份证号码" :value="info.identityCardNo"/>
            <van-cell title="民族" :value="info.nationalName"/>
            <van-cell title="性别" :value="info.gender==1?'男':'女'"/>
            <van-cell title="手机号码" :value="info.mobile"/>
            <van-cell title="民族" :value="info.nationalName"/>

            <van-cell title="团内现任职务" :value="info.positionName"/>
            <van-cell title="入团年月" :value="info.joinLeagueTime"/>
            <van-cell title="发展团员编号" :value="info.userCode"/>
        </van-cell-group>

        <div class="process">
            <div>审批进度</div>
            <div class="processStatus">
                <span>团支部及直属上级审批</span>
                <span>等待审批</span>
            </div>
        </div>
        <van-popup v-model="dialogVisibleReturn" style="width: 80%" round>

            <div style="padding: 20px 20px 10px;background-color: #e32322; color: white; text-align: center">撤销原因</div>
            <div>
                <van-field
                        v-model="auditReturnResult"
                        rows="3"
                        autosize
                        type="textarea"
                        placeholder="请输入撤销原因（必填）"
                />
            </div>
            <div style="text-align: center; margin-bottom: 10px">
                <van-button color="#e32322" style="width: 6em; margin-right: 5px" @click="revoke">撤销</van-button>
                <van-button style="width: 6em;" @click="dialogVisibleReturn = false">取消</van-button>

            </div>
        </van-popup>

    </div>


</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: "adminChange",

        computed: {
            ...mapState({
                curUser: state => state.user,
                curParams: state => state.commonparams
            }),

        },
        data() {
            return {
                publicPath: process.env.BASE_URL,
                active: 0,
                show: false,
                message: '',
                info: {},
                leagueList: [
                    {
                        "leagueId": "7v3vlzs4Qu_R24SkjJM9xQ==",
                        "leagueName": "喵喵",
                        "leagueFullName": "四川省成都市锦江区天猫喵喵团支部",
                        "leagueTypeId": "01TZB",
                        "industryTypeId": "05PTGZ",
                        "istzb": 0
                    },
                    {
                        "leagueId": "WE6A8oVjzk3zYn7OiTklCQ==",
                        "leagueName": "喵喵",
                        "leagueFullName": "四川省成都市锦江区天猫唯品会喵喵团支部",
                        "leagueTypeId": "01TZB",
                        "industryTypeId": "15QT",
                        "istzb": 0
                    }
                ],
                jobs: {
                    111: "书记",
                    222: "书记",
                    333: "书记",
                    444: "书记",
                    555: "书记",
                },
                dialogVisibleReturn: false,
                auditReturnResult: '',

            }
        },
        created() {
            console.log(this.$route.path)
            this.fetchData()
        },
        methods: {
            logOut() {
                console.log("logOut")
                let self = this
                let param = new FormData()

                this.loading = true
                this.$root.PF('/signout', param, {})
                    .then(function (response) {
                        console.log(response)
                        self.loading = false

                        if (response.status == 200) {
                            self.$store.commit('CLEAR')
                            self.$store.commit('CLEAR_PARAMS')
                            window && window.localStorage.clear()
                            self.jump('/')
                        }
                    })
                    .catch(function (error) {
                        if (error.response) {

                        } else if (error.request) {
                            console.log(error.request);

                        } else {
                            // Something happened in setting up the request that triggered an Error
                            console.log('Error', error.message);
                        }
                        console.log(error.config);
                    });
            },
            fetchData() {
                let param = new FormData()


                let ins = this.$root.PF('/unmemberRegisterTuanganInfo', param);
                ins.then((response) => {
                    if (response.status == 200) {
                        if (response.data.retCode === 1000) {
                            console.log(response.data.results)
                            this.info = response.data.results
                        } else {
                            if (response.data.retCode == 1516) {
                                this.$toast.fail({
                                    message: response.data.retMsg,
                                    onClose: () => {
                                        if (this.$route.path == '/unmember/') {
                                            this.reload()
                                        } else {
                                            this.$router.replace('/unmember/', () => {
                                                this.go(0)
                                            })
                                        }


                                    }
                                })
                            } else {
                                this.$dialog.alert({
                                    message: response.data.retMsg,
                                    theme: 'round-button',
                                })
                                // this.$toast.fail({
                                //     message: response.data.retMsg
                                // })
                            }

                        }
                    } else {
                        console.log("Got Return code:" + response.status)
                        this.$toast.fail({
                            message: '获取数据发生异常'
                        })
                    }
                })
                    .catch((error) => {

                    });
            },
            onLoad() {
                // 异步更新数据


                // 加载状态结束
                this.loading = false;

                // 数据全部加载完成
                if (this.list.length >= 40) {
                    this.finished = true;
                }
            },
            tapSubmit() {
                this.show = true
            },

            revokeStart() {
                this.dialogVisibleReturn = true
            },
            //撤销申请
            revoke() {
                if (this.info.id.length <= 0) {
                    this.$toast.fail({
                        message: "未找到必须的参数，请联系系统管理员"
                    })
                }
                if (this.auditReturnResult.length == 0) {
                    this.$toast.fail({
                        message: "请输入原因"
                    })
                    return
                }
                this.dialogVisibleReturn = false
                this.loading = true
                let param = new FormData()
                param.append('bid', this.info.id)
                this.PF('/revokeTuanganRegister', param).then((response) => {
                    this.loading = false
                    if (response.status == 200) {
                        if (response.data.retCode === 1000) {
                            this.$toast.success({

                                message: '撤销成功',
                                showClose: true,
                                duration: 2000,
                                onClose: () => {
                                    this.$router.go(0)
                                }
                            })
                        } else {
                            console.log("retCode:" + response.data.retCode)
                            this.$toast.fail({
                                message: response.data.retMsg
                            })
                        }
                    } else {
                        console.log("Got Return code:" + response.status)
                        this.$toast.fail({
                            message: '获取数据发生异常'
                        })
                    }
                }).catch((error) => {
                    this.loading = false

                });
            },

        }
    }
</script>

<style scoped>
    .wrap {
        background-color: #eeedf0;
        height: 100%;
        width: 100%;
        /*overflow-y: scroll;*/
    }

    .hd {
        width: 100%;
        height: 100px;
        background-color: #e32322;
        position: relative;
        padding-top: 50px;
        /*text-align: center;*/
    }

    .hd .info {
        width: 100px;
        height: 100px;
        position: absolute;
        bottom: -55px;
        left: 50%;
        margin-left: -55px;
    }

    .hd .info img {
        width: 100px;
        height: 100px;
        border: 3px solid white;
        background-color: white;
    }

    .hd .info p {
        width: 110px;
        text-align: center;
        font-size: 20px;
        color: #434343;
        margin: 5px 0;
    }

    .van-steps {
        margin-top: 100px;
    }

    .process {
        background-color: white;
        display: flex;
        flex-direction: column;
        text-align: center;
        margin-top: 20px;
    }

    .process div {
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #eeedf0;
        font-size: 15px;
        color: #656565;
    }

    .processStatus {
        display: flex;
        justify-content: space-between;
    }

    .processStatus span {
        flex: 1;
        text-align: center;
        font-size: 15px;
        color: #656565;
    }

    .processStatus span:nth-child(2) {
        color: #e32322;
        border-left: 1px solid #eeedf0;
    }

    .btn_wrap {
        width: 80%;
        height: 40px;
        margin: 20px auto;
    }

    .van-field {
        width: 90%;
        margin: 10px auto;
        background-color: #eeedf0;
        border-radius: 5px;
    }

    .van-cell-group {
        margin-top: 20px;
    }

    /deep/ .van-col {
        text-align: center;
    }

    /deep/ .van-button--normal {
        width: 100%;
        border-radius: 5px;
    }

    /deep/ .van-dialog__header {
        color: #656565;
        font-weight: normal;
    }

    /deep/ .van-dropdown-menu__title {
        color: #969799;
    }

    /deep/ .van-step__line {
        background-color: #c5c5c5;
    }

    /deep/ .van-steps {
        background-color: transparent;
    }

    /deep/ .van-step--horizontal .van-step__circle-container {
        background-color: #eeedf0;
    }

    /deep/ .van-step--horizontal .van-step__icon, /deep/ .van-step--horizontal .van-step__title {
        font-size: 14px;
    }

</style>
